/**
 * Entry for the isolated `tune-consent.js` bundle, loaded by every Django
 * template (index.html, landing/index.html, base_embed.html). Built by
 * `yarn build:consent` into dist/tune-consent.js. The CSS is inlined into the
 * shadow root, so there is no separate stylesheet to link.
 */
import { mountConsent } from './mount'

// bundle-text inlines the compiled consent.css as a string. Loaded with
// require() so Parcel's CSS optimizer does not treat it as a CSS-module import
// (a default/namespace ES import triggers its "cannot be tree shaken" warning).
declare const require: (id: string) => string | { default: string }
const raw = require('bundle-text:./consent.css')
const css: string = typeof raw === 'string' ? raw : raw.default
const start = () => mountConsent({ css })
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
else start()
